// Shared display helpers for outcome/game rows (Live Discovery + the dashboard
// multi-outcome table render the same price + status chips).
import { cn } from '@/lib/infra/utils';

type GameState = 'live' | 'pre' | 'final';

export function pct(cents: number | null | undefined): string {
  return cents == null ? '—' : `${cents}¢`;
}

export function StatusPill({ state }: { state: GameState }) {
  const cls =
    state === 'live'
      ? 'bg-positive/15 text-positive'
      : state === 'final'
        ? 'bg-muted text-muted-foreground'
        : 'bg-amber-500/15 text-amber-400';
  const label = state === 'live' ? 'LIVE' : state === 'final' ? 'FINAL' : 'PRE';
  return <span className={cn('rounded px-1.5 py-0.5 text-[10px] font-bold', cls)}>{label}</span>;
}
